import { Tag } from "lucide-react";
import type { ToolWidgetProps } from "./index";

interface Category {
  fsq_id: string;
  name: string;
  label?: string;
  level?: number;
  child_ids?: string[];
  child_count?: number;
}

interface FoursquareCategoriesData {
  results: Category[];
  count: number;
}

export function FoursquareCategoriesWidget({
  data,
  count,
}: ToolWidgetProps<FoursquareCategoriesData>) {
  const { results = [] } = data || {};

  if (!results.length) {
    return (
      <div className="text-sm text-slate-500 italic">
        Aucune catégorie trouvée
      </div>
    );
  }

  return (
    <div className="space-y-3">
      <div className="flex flex-wrap gap-2">
        {results.map((category) => (
          <div
            key={category.fsq_id}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white border border-slate-200 rounded-full text-sm text-slate-700 hover:border-slate-300 transition-colors"
          >
            <Tag className="w-3.5 h-3.5 text-slate-400" />
            <span>{category.name}</span>
            {category.child_count !== undefined && category.child_count > 0 && (
              <span className="text-xs text-slate-400">
                (+{category.child_count})
              </span>
            )}
          </div>
        ))}
      </div>
      {count && count > results.length && (
        <div className="text-xs text-slate-400 text-center">
          + {count - results.length} autres catégories
        </div>
      )}
    </div>
  );
}
